// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import runOnVisible from '../runner-visible';
import arrayPush from 'lodash-es/_arrayPush';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'weekly-plan';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class WeeklyPlan {
  constructor(el) {
    this.el = el;
    this.swiper = null;

    this.$swiperContainer = $(el).find('.swiper-container');
    this.$swiperPrev = $(el).find('.swiper-button-prev');
    this.$swiperNext = $(el).find('.swiper-button-next');
    this.$swiperSlide = $(el).find('.swiper-slide');

    runOnVisible(el, async () => {
      await this.textHeight();
      await this.initSlideshow();
    });
  }

  async initSlideshow() {
    const {
      default: Swiper,
      Navigation: SwiperNavigation
    } = await import('swiper/core');

    Swiper.use([SwiperNavigation]);

    this.swiper = new Swiper(this.$swiperContainer[0], {
      // @see https://swiperjs.com/swiper-api
      slidesPerView: 'auto',

      navigation: {
        prevEl: this.$swiperPrev[0],
        nextEl: this.$swiperNext[0],
      },

      observeParents: true,
      observeSlideChildren: true,
      observer: true,

      speed: (1000 * (5 / 8)),
    });
  }

  async textHeight() {
    let arrayText = [];

    function findHighestDiv(nodeList) {
      let maxHeight = 0;
      let highestDiv = null;
      let highestDivIndex = -1; // Startwert für Index

      nodeList.forEach(function(element, index) {
        const elementHeight = element.offsetHeight;
        if (elementHeight > maxHeight) {
          maxHeight = elementHeight;
          highestDiv = element.offsetHeight;
          highestDivIndex = index; // Aktualisierung des Index
        }
      });

      return { highestDiv, highestDivIndex };
    }

    for (let item of this.$swiperSlide) {
      const textElements = item.querySelectorAll('.weekly-plan__text');
      arrayText.push(findHighestDiv(textElements));
    }

    const uniqueArray = [];

    for (let item of arrayText) {
      const existingItem = uniqueArray.find(obj => obj.highestDivIndex === item.highestDivIndex);

      if (existingItem) {
        if (item.highestDiv > existingItem.highestDiv) {
          existingItem.highestDiv = item.highestDiv;
        }
      } else {
        uniqueArray.push(item);
      }
    }

    for (let index = 0; index < this.$swiperSlide.length; index++) {
      let item = this.$swiperSlide[index];
      let textElements = item.querySelectorAll('.weekly-plan__text');

      textElements.forEach((element, index2) => {
        const existingItem = uniqueArray.find(obj => obj.highestDivIndex === index2);

        if (existingItem) {
          element.style.height = `${existingItem.highestDiv}px`
        }
      });
    }
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new WeeklyPlan(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
